import gql from 'graphql-tag';

export default gql`
  query getEvent($id: Int!) {
    getEvent(id: $id) {
      id
      header_desktop
      header_mobile
      visual_desktop
      visual_mobile
      fb_cover
      category_id
      category {
        id
        details {
          label
          language_id
        }
      }
      promote_homepage
      event_date
      details {
        id
        name
        slug
        date
        introduction
        content
        cta_text
        cta_url
        tags
        description
        section_instagram_title
        meta_title
        meta_description
        meta_tags
        meta_og_title
        meta_og_description
        meta_og_url
        fb_title
        fb_date
        fb_location
        fb_cta_label
        fb_cta_url
        language_code
      }
      blocks
    }
  }
`;



// WEBPACK FOOTER //
// ./src/apollo/graphql/event/get.js